import React from "react";
import numberthree from "../../Images/numberthree.png";
import { useTranslation } from "react-i18next";
export default function Loreal() {
  const { t, i18n } = useTranslation();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          backgroundColor: "red",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src={numberthree}
          alt="logo"
          style={{
            minWidth: "150px", // Adjust the size
            height: "150px", // Adjust the size
            width: "150px", // Adjust the size

            borderRadius: "50%", // Makes the image circular
            objectFit: "cover", // Ensures the image covers the circle without stretching
            border: "2px solid #ccc", // Optional: Adds a border
          }}
        />
      </div>
      <div
        style={{
          display: "flex",
          //backgroundColor: "green",
          flexDirection: "row",
          justifyContent: "space-evenly",
        }}
      >
        <p>Skin Care</p>
        <p>Make Up</p>
        <p>Hair Care</p>
        <p>Hair Colour</p>
        <p>Men</p>
      </div>
    </div>
  );
}
